import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Link } from 'ngx-linkifyjs';

@Injectable({
  providedIn: 'root'
})
export class LinkPreviewService {
  cachingHeader = new HttpHeaders().set('CallCacheInterceptor', '');
  private devCode = 'hEfjZ/nb8CiQCDKpzT4QLzm4Al/CNEM9mZMFvnU2BfD3a3tWbfbePA==';
  private devApiURL = 'https://findcrsdeveventtrigger.azurewebsites.net/api/CrawlUrl';

  // feedback crs
  private liveCode = 'LUWj0SU3/ocYUsvAxI4MGFkjURMHQZf4QU6BhBmNE5jaXo42in4qng==';
  private liveApiURL = 'https://findcrseventtrigger.azurewebsites.net/api/CrawlUrl';
  
  // Find crs
  // private liveCode = 'V0G6X6Oq/Csl5RLQUQLwOCwado6IMWOtlwa03/YI6E0OK4PcIiEMWg==';
  // private liveApiURL = 'https://findacrseventtrigger.azurewebsites.net/api/CrawlUrl';

  links: Link[] = [];

  constructor(private http: HttpClient) {
  }

  fetchLink(url: string, postId): Observable<any> {
    if (window.localStorage.getItem("testEnv") === "dev") {
      const httpParams = new HttpParams()
        .append('code', this.devCode)
        .append('url', url)
        .append('postId', postId);
      return this.http.get(this.devApiURL, { params: httpParams, headers: this.cachingHeader })
        .pipe(map((value: any) => value));
    } else {
      const httpParams = new HttpParams()
        .append('code', this.liveCode)
        .append('url', url)
        .append('postId', postId);
      return this.http.get(this.liveApiURL, { params: httpParams, headers: this.cachingHeader })
        .pipe(map((value: any) => value));
    }
  }

  fetchFeedPreviewLinks(url) {
    return this.http.get(`https://api.linkpreview.net/?key=5b54e80a65c77848ceaa4630331e8384950e09d392365&q=${url}`)
      .pipe(map((value: any) => value));
  }
}
